import { Observable, Observer } from 'rxjs';

import { createImageUrl } from '@shared/utils/object-mapper.util';

import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';

const checkImageDimension = (file: NzUploadFile): Promise<boolean> => {
  return new Promise(resolve => {
    const img = new Image();

    img.src = window.URL.createObjectURL(file);

    img.onload = () => {
      const width = img.naturalWidth;

      const height = img.naturalHeight;

      window.URL.revokeObjectURL(img.src);
      resolve(width === height && width < 2000);
    };
  });
};

export const beforeUploadImage = (file: NzUploadFile, messageService: NzMessageService): boolean | Observable<boolean> => {
  return new Observable((observer: Observer<boolean>) => {
    const isJPGorPNG = file.type === 'image/jpeg' || file.type === 'image/png';

    if (!isJPGorPNG) {
      messageService.error('You can upload a JPG or PNG file!');
      observer.complete();
      return;
    }

    const isLt500K = file.size / 1024 < 500;

    if (!isLt500K) {
      messageService.error('Image must smaller than 500KB!');
      observer.complete();
      return;
    }

    checkImageDimension(file).then(dimensionRes => {
      if (!dimensionRes) {
        messageService.error('Upload failed: Image must be square. Max size: 2000x2000px');
        observer.complete();
        return;
      }

      observer.next(isJPGorPNG && isLt500K && dimensionRes);
      observer.complete();
    });
  });
};

export const uploadImage = (item: NzUploadXHRArgs, imageService, messageService, imageLoading: boolean, callback) => {
  const formData = new FormData();

  formData.append('file', item.file as any);

  imageLoading = true;

  return imageService.uploadImage(formData).subscribe(response => {
    callback(createImageUrl(response.image));
    imageLoading = false;
    messageService.success('Upload successfully!');
  }, () => {
    imageLoading = false;
    messageService.error('Error while uploading image!');
  });
};
